export const EV_PATHS = {
  START: "/smart-charging/ev/start/",
  COMPATIBILITY: "/smart-charging/ev/compatibility",
  TERMS: "/smart-charging/ev/terms",
};

export const EV_ROUTES = [
  EV_PATHS.START,
  EV_PATHS.COMPATIBILITY,
  EV_PATHS.TERMS,
];
